<template>
  <div class="purchase">
    <div class="top-container">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="100px"
      >
        <div class="row">
          <!-- v-if="!isCanteenAdmin" -->
          <el-form-item label="食堂：" prop="canteen" >
            <el-select
              v-model="ruleForm.canteen"
              placeholder="请选择"
              class="w240"
              clearable
            >
              <el-option
                v-for="item in canteenList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采购类型：" prop="purchaseType">
            <el-select
              v-model="ruleForm.purchaseType"
              placeholder="请选择"
              class="w240"
            >
              <el-option
                v-for="item in purchaseTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发起时间：" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              class="white w240"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="采购人：" prop="purchasePeople">
            <el-input class="gray white w240" placeholder="请输入" v-model="ruleForm.purchasePeople"></el-input>
          </el-form-item>
          <el-form-item label="费用生成：" prop="isCreateExpense">
            <el-select
              v-model="ruleForm.isCreateExpense"
              placeholder="请选择"
              class="w240"
            >
              <el-option
                v-for="item in isCreateExpenseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否报销：" prop="isReimbursement">
            <el-select
              v-model="ruleForm.isReimbursement"
              placeholder="请选择"
              class="w240"
            >
              <el-option
                v-for="item in isReimbursementList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="btn">
            <el-button class="btn-gray" @click="resetForm('ruleForm')">重置</el-button>
            <el-button class="btn-blue" type="primary" @click="search">搜索</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="container">
      <div class="title-container">
        <div class="title">采购列表</div>
        <div class="title-btn">
          <el-button
            type="text"
            class="btn-border-text-blue"
            @click="purchasePrint"
            >前往打印</el-button
          >
          <el-button
            type="text"
            class="btn-blue"
            @click="createdExpense"
            >生成费用单</el-button
          >
        </div>
      </div>
      <div class="table" v-if="tableData.length > 0">
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="60" :selectable="setDisableSelectTable"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :width="item.width"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <p v-if="item.prop != 'amount' && item.prop != 'createTime' && item.prop != 'reimbursementTime'">{{scope.row[item.prop]}}</p>
              <div v-if="item.prop == 'createTime'">
                <span>{{scope.row.createTime}}</span>
                <el-tooltip
                  v-if="scope.row.isDiffTime"
                  effect="dark"
                  placement="top">
                  <div slot="content">
                    录入日期非采购当天
                  </div>
                  <img class="err-sign" src="../../../../assets/food/err.png">
                </el-tooltip>
              </div>
              <div v-if="item.prop == 'reimbursementTime'">
                <span>{{scope.row.reimbursementTime}}</span>
                <el-tooltip
                  v-if="scope.row.isCreateExpense"
                  effect="dark"
                  placement="top">
                  <div slot="content">
                    已生成费用单
                  </div>
                  <img class="create-expense" src="../../../../assets/food/create-expense.png">
                </el-tooltip>
              </div>
              <div v-if="item.prop == 'amount'">
                <el-tooltip
                  effect="dark"
                  :disabled="!scope.row.adminCancel"
                  placement="top">
                  <div slot="content">
                    该采购单不纳入计算
                  </div>
                  <p :class="scope.row.adminCancel?'hign-text':''">{{scope.row.amount}}</p>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="btn-text"
                @click="lookDetails(scope.row.id)"
                >查看详情</el-button
              >
              <el-button
                v-if="scope.row.adminCancel"
                type="text"
                class="btn-text"
                @click="recovery(scope.row.id)"
                >恢复</el-button
              >
              <el-button
                v-else
                type="text"
                class="btn-text-red"
                @click="nullify(scope.row.id)"
                >作废</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-tpl-container">
          <pagination-tpl
            :total="totalNum"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @queryChange="onQueryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div class="nothing" v-if="tableData.length == 0">
        <div>
          <div>
            <img src="../../../../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>
    
    <!-- 查看详情 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="840px"
      :before-close="handleClose"
    >
      <el-table
        :data="tableDetailsData"
        show-summary
        :summary-method="getSummaries"
        height="352px"
      >
        <el-table-column
          v-for="(item, index) in tableDetailsTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.lable"
          :width="item.width"
          show-overflow-tooltip
        />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <div class="upload-left">
          <div class="upload-title">已传附件：</div>
          <div class="downFile" v-if="images.length > 0" @click="downFile">
            {{ fileList[0].name }}
          </div>
          <!-- <el-upload
            class="upload"
            ref="upload"
            action="#"
            :class="images.length < 1 ? '' : 'none'"
            :limit="1"
            :on-exceed="handleLimit"
            :on-remove="onRemove"
            :before-upload="beforeUpload"
            :auto-upload="true"
            :file-list="fileList"
            disabled
          >
            <i class="el-icon-plus"></i>
            <div v-if="fileList.length == 0" slot="tip" class="el-upload__tip" >{{ uploadTips }}</div>
          </el-upload> -->
        </div>
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="openPrint">打印</el-button>
        </div>
      </span>
    </el-dialog>

    <!-- 打印 -->
    <el-dialog class="printer-dialog" top="10vh" :visible.sync="printerDialog" width="760px">
      <div class="printer" id="printer">
        <div>
          <p class="printer-title">打印</p>
          <div class="printer-message">
            <ul class="list">
              <li class="list-item">日期：{{ purchaseDate }}</li>
              <li class="list-item">采购类型：{{ purchaseType[type] }}</li>
            </ul>
            <ul class="list list-right">
              <li class="list-item">采购人：{{ type != 3 ? userName: supplierName }}</li>
            </ul>
          </div>
          <div class="table">
            <el-table class="table-printer" :data="tableDetailsData" style="width:100%">
              <el-table-column
                v-for="(item, index) in tableDetailsTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.lable"
                :width="item.width"
                show-overflow-tooltip
              />
            </el-table>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button class="btn-white" @click="closePrinterDialog">取消</el-button>
        <el-button class="btn-blue" v-print="'#printer'">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="create-expense-dialog"
      :visible.sync="dialogCreateExpenseVisible"
      width="540px"
      :before-close="handleCreateExpenseClose"
    >
      <div slot="title">
        <span>生成费用单</span>
        <el-tooltip
          effect="dark"
          placement="right">
          <div slot="content">
            费用单生成后，请在手机端及时发起报销
          </div>
          <img class="tooltip" src="../../../../assets/tooltip.png" alt>
        </el-tooltip>
      </div>
      <el-form
        ref="createExpenseForm"
        :model="createExpenseForm"
        :rules="createExpenseFormRules"
        class="demo-ruleForm"
      >
        <el-form-item label="是否有发票" prop="hasInvoice">
          <el-select
            v-model="createExpenseForm.hasInvoice"
            placeholder="请选择"
          >
            <el-option
              v-for="item in hasInvoiceList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="createExpenseForm.hasInvoice === 1" label="上传发票（最多上传9张）" prop="img" class="invoice">
          <el-upload
            element-loading-text="文件上传中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            class="upload"
            ref="upload"
            action="#"
            list-type="picture-card"
            :auto-upload="true"
            :on-exceed="handleLimitInvoice"
            :before-upload="beforeInvoiceUpload"
            :on-remove="onRemoveInvoice"
            :file-list="fileInvoiceList"
            :limit="limit"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="createExpenseForm.date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            class="white"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开支内容" prop="content">
          <el-input class="gray white" placeholder="请输入" v-model="createExpenseForm.content"></el-input>
        </el-form-item>
        <el-form-item label="金额（元）" prop="amount">
          <el-input class="gray white" placeholder="请输入" v-model="createExpenseForm.amount"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button @click="handleCreateExpenseClose">取 消</el-button>
          <el-button type="primary" @click="confirmCreateExpense('createExpenseForm')">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
import { formatTimeToDate, handleAmount, keepTwoDecimal, debounce } from "@/common/js/utils.js"
import Purchase from "@/models/purchase.js"
import Canteen from "@/models/canteen.js";
import ImgUploader from "@/models/img-upload.js";
const imgUploader = new ImgUploader();
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      /* 是否是食堂管理员; 1.是， 0，不是 */
      isCanteenAdmin: 1,
      tableData: [],
      tableTitleList: [
        { prop: "canteen", lable: "食堂", width: "" },
        { prop: "entryTime", lable: "录入日期", width: "" },
        { prop: "createTime", lable: "采购日期", width: "" },
        { prop: "reimbursementTime", lable: "报销日期", width: "" },
        { prop: "purchasePeople", lable: "采购人", width: "" },
        { prop: "purchaseType", lable: "采购类型", width: "" },
        { prop: "amount", lable: "金额", width: "" },
      ],
      totalNum: 0,
      currentPage: 1,
      pageSize: 50,
      ruleForm: {
        canteen: '',
        date: '',
        purchasePeople: '',
        purchaseType: '',
        isCreateExpense: null,
        isReimbursement: null
      },
      isCreateExpenseList: [
        {id:1, name: '是'},
        {id:0, name: '否'}
      ],
      isReimbursementList: [
        {id:1, name: '是'},
        {id:0, name: '否'}
      ],
      canteenList: [],
      purchaseTypeList: [
        {id:1, name: '零星采购'},
        {id:2, name: '定点采购'},
        {id:3, name: '配送'},
      ],
      dialogTitle: '查看详情',
      dialogVisible: false,
      tableDetailsData: [],
      tableDetailsTitleList: [
        { prop: "type", lable: "分类", width: "" },
        { prop: "name", lable: "物料名称", width: "" },
        { prop: "unitPrice", lable: "单价", width: "" },
        { prop: "nums", lable: "数量", width: "" },
        { prop: "discount", lable: "优惠金额", width: "" },
        { prop: "total", lable: "小计", width: "" },
      ],
      purchaseType: {
        1: '零星采购',
        2: '定点采购',
        3: '定点配送'
      },
      //打印弹窗
      printerDialog: false,
      // 采购人
      userName: '',
      supplierName: '',
      // 采购类型
      type: '',
      // 采购日期
      purchaseDate: '',
      uploadTips: "",
      images: [],
      fileList: [],
      // 选中生成费用单的数据
      selectCreateExpenseList: [],
      dialogCreateExpenseVisible: false,
      hasInvoiceList: [
        {id:1, name: '是'},
        {id:0, name: '否'}
      ],
      createExpenseForm: {
        hasInvoice: 1,
        img: [],
        date: '',
        content: null,
        amount: null
      },
      createExpenseFormRules: {
        hasInvoice: [
          { required: true, message: "请选择是否有发票", trigger: "change" },
        ],
        img: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
        date: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        content: [{ required: true, message: "请输入开支内容", trigger: "blur" }],
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }]
      },
      limit: 9,
      fileInvoiceList: []
    }
  },

  created() {
    config()
    // if (this.isCanteenAdmin) {
    //   this.tableTitleList.shift()
    // }
    this.initCanteenList()
    this.initTableList()
    
    this.debounceSubmitFnc = debounce(() => {
      this.confirmCreateExpenseFnc()
    }, 1000)
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.emit('isShowTopMenu', false)
    })
  },

  methods: {
    initTableList() {
      let data = {}
      data.canteenId = this.ruleForm.canteen
      data.username = this.ruleForm.purchasePeople
      data.startTime = this.ruleForm.date ? this.ruleForm.date[0] : ''
      data.endTime = this.ruleForm.date ? this.ruleForm.date[1] : ''
      data.type = this.ruleForm.purchaseType
      data.hasCreateBill = this.ruleForm.isCreateExpense
      data.hasReimburse = this.ruleForm.isReimbursement
      data.currentPage = this.currentPage
      Purchase.getPurchaseList(data).then(res => {
        if (res.success) {
          let arr = []
          this.totalNum = res.result.totalNum
          res.result.items.map((i) => {
            let obj = {}
            obj.id = i.id
            obj.canteen = i.canteenName
            obj.purchasePeople = i.username
            obj.amount = handleAmount(i.totalPrice,2)
            obj.createTime = i.createTime ? formatTimeToDate(i.createTime) : ''
            obj.entryTime = i.entryTime ? formatTimeToDate(i.entryTime) : ''
            obj.reimbursementTime = i.reimburseDate ? formatTimeToDate(i.reimburseDate) : '—'
            obj.isCreateExpense = i.hasCreateBill
            obj.type = i.type
            obj.isDiffTime = i.isDiffTime
            obj.adminCancel = i.adminCancel
            obj.purchaseType = this.purchaseType[i.type]
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    initDetails(id) {
      Purchase.getPurchaseDetails(id).then(res => {
        if (res.success) {
          let arr = []
          let { userName, type, elementList, createTime, supplierName, enclosure } = res.result
          this.userName = userName
          this.supplierName = supplierName
          this.type = type
          this.purchaseDate = formatTimeToDate(createTime)
          if (enclosure.length > 0) {
            this.images = enclosure
            let fileList = []
            enclosure.map(i => {
              let obj = {}
              obj.url = i
              obj.name = i.split('img/')[1].substring(13)
              fileList.push(obj)
            }) 
            this.fileList = fileList
          }
          elementList.map(i => {
            let obj = {}
            obj.type = i.categoryName
            obj.name = i.materialName
            obj.nums = handleAmount(i.checkNum,2)
            obj.unitPrice = handleAmount(i.checkUnitPrice,2)
            obj.discount = handleAmount(i.discount,2)
            obj.total = handleAmount(i.checkSubtotal,2)
            arr.push(obj)
          })
          this.tableDetailsData = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 食堂数据 */
    initCanteenList() {
      Canteen.getCanteenNoPageList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            arr.push(obj)
          })
          this.canteenList = arr
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initTableList();
    },

    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initTableList();
    },

    /* 重置 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    lookDetails(id) {
      this.dialogVisible = true
      this.initDetails(id)
    },

    handleClose() {
      this.uploadTips = ""
      this.images = []
      this.fileList = []
      this.dialogVisible = false
    },

    /* 合拼单元格 */
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index != columns.length - 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          let subtotal = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          sums[index] = keepTwoDecimal(subtotal)
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    
    /* 开启打印 */
    openPrint() {
      this.printerDialog = true
    },
    
    /* 关闭打印 */
    closePrinterDialog() {
      this.printerDialog = false;
    },

    /* 图片数量大于1 */
    handleLimit() {
      this.$message({
        message: "文件数量最多1张",
        type: "warning",
      });
    },

    /* 删除图片 */
    onRemove(file, fileList) {
      this.fileList = fileList;
      this.images = [];
      this.fileList.map((value, index, Array) => {
        this.images.push(value.url);
      });
    },

    /* 上传图片进行判断图片 */
    beforeUpload(file) {
      const isFile =
        file.type === "application/msword"||
        file.type === "application/vnd.ms-excel" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isLt5M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
      if (!isFile) {
        this.$message.error("上文件格式错误!");
        return false;
      } else if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
        return false;
      } else {
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              obj.name = res.name
              this.fileList.push(obj);
              this.images = [];
              this.fileList.map((value, index, Array) => {
                this.images.push(value.url);
              });
            } else {
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },

    downFile() {
      let url = this.images[0]
      window.open(url)
    },

    purchasePrint() {
      this.$router.push({
        path: '/fire/foodModuleIndex/purchaseIndex/printIndex/printDailyConsumption'
      })
    },

    /* 恢复作废 */
    recovery(id) {
      Purchase.getRecoveryPurchase(id).then(res => {
        if (res.success) {
          this.initTableList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    nullify(id) {
      Purchase.getNullifyPurchase(id).then(res => {
        if (res.success) {
          this.initTableList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    createdExpense() {
      if (this.selectCreateExpenseList.length === 0) return this.$message.error('请先选择未生成费用单且未作废的采购单')
      this.dialogCreateExpenseVisible = true
    },

    setDisableSelectTable(row) {
      let isBoolean = row.isCreateExpense == 1 || row.adminCancel
      return !isBoolean
    },

    handleSelectionChange(v) {
      let selectCreateExpenseList = []
      let amount = 0
      v.map(i => {
        selectCreateExpenseList.push(i.id)
        amount += i.amount
      })
      this.createExpenseForm.amount = keepTwoDecimal(amount)
      this.selectCreateExpenseList = selectCreateExpenseList
    },

    handleCreateExpenseClose() {
      this.createExpenseForm = {
        hasInvoice: 1,
        img: [],
        date: '',
        content: null,
        amount: null
      }
      this.fileInvoiceList = []
      this.dialogCreateExpenseVisible = false
    },

    confirmCreateExpense() {
      this.debounceSubmitFnc()
    },

    confirmCreateExpenseFnc() {
      let formName = 'createExpenseForm'
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let hasInvoice = this.createExpenseForm.hasInvoice
          let date = this.createExpenseForm.date
          let amount = handleAmount(this.createExpenseForm.amount,1)
          let expenditureContent = this.createExpenseForm.content
          let picUrl = this.createExpenseForm.img
          let purchaseIdList = this.selectCreateExpenseList
          let data = {
            hasInvoice,
            date,
            amount,
            expenditureContent,
            picUrl,
            purchaseIdList
          }
          Purchase.postCreateExpense(data).then(res => {
            if (res.success) {
              this.initTableList()
              this.handleCreateExpenseClose()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    handleLimitInvoice() {
      this.$message({
        message: "图片数量最多9张",
        type: "warning",
      });
    },

    onRemoveInvoice(file, fileList) {
      this.fileInvoiceList = fileList;
      let images = [];
      this.fileInvoiceList.map((value, index, Array) => {
        images.push(value.url);
      });
      this.createExpenseForm.img = images;
    },

    beforeInvoiceUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      } else {
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then(res => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              obj.name = res.name
              this.fileInvoiceList.push(obj);
              let images = [];
              this.fileInvoiceList.map((value, index, Array) => {
                images.push(value.url);
              });
              this.createExpenseForm.img = images;
            } else {
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    }
  }
}
</script>

<style lang='scss'>
.purchase {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: $bg-WhiteSmoke;
  .top-container {
    box-sizing: border-box;
    background: $bg-white;
    padding: 10px;
    .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin-bottom: 10px
    }
    .el-input__prefix, .el-input__suffix {
      top: -3px;
    }
    .row {
      @include flex-start;
      flex-wrap: wrap;
      .btn {
        margin-left: 30px;
        margin-bottom: 7px;
        .el-form-item__content {
          margin-left: 0px!important;
          display: flex;
        }
      }
    }
  }
  .container {
    flex: 1;
    height: 100%;
    margin-top: 20px;
    padding: 20px;
    box-sizing: border-box;
    background: $bg-white;
    position: relative;
    .title-container {
      @include flex-between;
      margin-bottom: 20px;
      .title {
        font-size: $fs-medium-s;
        color: $color-BlackGrey;
      }
      .title-btn {
        display: flex;
      }
    }
    .table-billCode {
      color: $color-DeepReddishBlue;
    }
    .err-sign,
    .create-expense {
      height: 16px;
      margin-left: 7px;
      margin-bottom: 4px;
    }
    .err-sign {
      width: 14px;
    }
    .create-expense {
      width: 12px;
    }
    .table-status {
      @include flex-start;
      .spot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 6px;
      }
      .red {
        background: $bg-Crimson;
      }
      .blue {
        background: $bg-DeepReddishBlue;
      }
      .green {
        background: $bg-LawnGreen;
      }
      .spot-gray {
        background: $bg-SpotGray;
      }
    }
  }
  .hign-text {
    color: $color-Crimson;
  }
  
  .nothing {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }

  .el-dialog__header,
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__body {
    padding: 0px 20px
    
  }
  .el-dialog__body  .el-table__body-wrapper.is-scrolling-none {
    height: 261px!important;
    overflow-y: auto;
  }
  .el-table .cell, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
    padding-left: 16px;
  }
  
  .el-table__header-wrapper {
    background: $bg-table;
    .el-table__header {
      tr {
        th {
          background: $bg-table;
          padding: 0;
          height: 44px;
          .cell {
            color: $color-BlackGrey;
            line-height: 16px;
            padding: 8px 16px;
            font-size: $fs-small-l;
          }
        }
      }
    }
  }
  .el-table__footer-wrapper {
    tbody td {
      background: $bg-white;
      border-bottom: 0; 
    }
  }
  .el-dialog__footer {
    @include flex-end;
    .dialog-footer {
      width: 100%;
      @include flex-between;
    }
    .downFile {
      font-size: $fs-small-l;
      color: $color-DeepReddishBlue;
      cursor: pointer;
    }
    .upload-left {
      @include flex-start;
      .upload-title {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-Step;
      }
      .upload {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        .el-icon-plus {
          color: $bg-DeepReddishBlue;
          border: 1px solid $bg-DeepReddishBlue;
          border-radius: 50%;
        }
        .none {
          .el-upload--picture-card {
            display: none;
          }
        }
        .el-upload-list__item:first-child {
          margin-top: 0px;
        }
        .el-upload__tip {
          margin: 0;
          margin-right: 11px;
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-UploadTips;
        }
      }
    }
  }
  .printer-dialog .footer {
    height: 80px;
    line-height: 80px;
    text-align: right;
  }
  .create-expense-dialog {
    .tooltip {
      margin-left: 4px;
    }
    .dialog-footer {
      @include flex-end
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 100%;
    }
    .el-dialog__body .el-form {
      padding: 0px;
    }
    .invoice {
      .el-form-item__label {
        width: 100%;
        text-align: left;
      }
      .el-form-item__content {
        height: 66px;
      }
    }
    
    .el-form-item.is-required:not(.is-no-asterisk)
      .el-form-item__label-wrap
      > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
      display: none;
    }
    .el-form-item.is-required:not(.is-no-asterisk)
      .el-form-item__label-wrap
      > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
      content: "*";
      color: $bg-Required;
      margin-left: 4px;
    }
    .el-form-item__label {
      line-height: 30px;
    }
    .upload {
      .el-upload {
        width: 36px;
        height: 36px;
        .el-icon-plus {
          width: 33px;
          height: 34px;
          @include flex-center;
        }
      }
      .el-upload--picture-card i {
        font-size: 18px;
      }
      .el-upload-list--picture-card .el-upload-list__item {
        width: 36px;
        height: 36px;
      }
      .el-upload-list--picture-card .el-upload-list__item-status-label {
        right: -20px;
        top: -11px;
      }
    }
  }
}
</style>

<style midia="print">
#printer .printer-title {
  height: 64px;
  font-size: 24px;
  line-height: 64px;
  text-align: center;
  margin-bottom: 20px;
}
#printer .printer-message {
  display: flex;
  justify-content: space-between;
}
#printer .printer-message .list {
  width: 50%;
}
#printer .printer-message .list .list-item {
  font-size: 12px;
  padding-bottom: 16px;
  text-align: left;
}
#printer .printer-message .list .list-right {
  width: 250px;
}
#printer .print-repair .list-right {
  margin-right: 160px;
}
#printer .table .el-table {
  border: 1px solid #000;
  border-radius: 4px 4px 0 0
}
#printer .el-table th.is-leaf {
  border-bottom: 1px solid #000;
}
#printer .table .el-table td {
  border-bottom: 1px solid #000;
}
#printer .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
  height: auto;
  line-height: 20px;
  font-size: 12px;
}
#printer .table th {
  width: 60px;
}
</style>
